// hooks/useCidades.ts
import { useFetch } from "./useFetch";
import { Apartamento } from "../interfaces/Apartamento";
import { apartamentoByEmpreendimentoService } from "../services/apartamentoByEmpreendimentoService";

export const useApartamentoByIdEmpreend = (empreendimentoId?: number) => {
  const { isLoading, data, error } = useFetch<Apartamento[]>(
    !!empreendimentoId, // só busca se tiver empreendimentoId
    apartamentoByEmpreendimentoService,
    [empreendimentoId],
    empreendimentoId
  );

  return { isLoading, data, error };
};
